import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../../configs/AppConfig";

const KotaService = {}

KotaService.data = function (token,search) {
    //console.log(search)
    return fetch({
        url: '/ref/kota',
        method: 'get',
        params: {
            search
        },
        headers:{
            "x-api-key":X_API_KEY,
        }
    })
}

export default KotaService;
